var _filter, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    style: {
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fillOpacity: 1
    },
    d: "M 3.570312 2.234375 C 7.179688 2.226562 10.789062 2.234375 14.398438 2.25 C 15.09375 2.433594 15.53125 2.871094 15.714844 3.570312 C 15.738281 7.179688 15.738281 10.785156 15.714844 14.398438 C 15.53125 15.09375 15.09375 15.53125 14.398438 15.714844 C 10.785156 15.738281 7.179688 15.738281 3.570312 15.714844 C 2.871094 15.53125 2.433594 15.09375 2.25 14.398438 C 2.226562 10.785156 2.226562 7.179688 2.25 3.570312 C 2.4375 2.871094 2.878906 2.425781 3.570312 2.234375 Z M 3.921875 3.359375 C 4.667969 3.359375 5.421875 3.359375 6.171875 3.359375 C 6.171875 7.109375 6.171875 10.855469 6.171875 14.609375 C 5.417969 14.613281 4.667969 14.609375 3.921875 14.589844 C 3.671875 14.574219 3.5 14.449219 3.410156 14.21875 C 3.351562 10.789062 3.339844 7.355469 3.375 3.921875 C 3.421875 3.597656 3.605469 3.410156 3.921875 3.359375 Z M 7.296875 3.359375 C 9.546875 3.351562 11.796875 3.359375 14.046875 3.375 C 14.367188 3.417969 14.546875 3.597656 14.589844 3.921875 C 14.613281 7.296875 14.613281 10.671875 14.589844 14.046875 C 14.546875 14.367188 14.367188 14.546875 14.046875 14.589844 C 11.796875 14.609375 9.546875 14.613281 7.296875 14.609375 C 7.296875 10.855469 7.296875 7.109375 7.296875 3.359375 Z M 7.296875 3.359375 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.4e689e0069725d6aafc2bcbc9ecfca6b.svg";
export { ForwardRef as ReactComponent };